import { DateFormat, formatDate, now } from "common";
import { Dayjs } from "dayjs";
import { SelectionState } from "types";
import create from "zustand";
import { AnalyticsMode, DateFilterRange } from "./analyticsFilterStore";

export interface CustomerAnalyticsFilter {
    products: SelectionState;
    mode: AnalyticsMode;
}

const defaultFilters = {
    products: { all: true, selected: [] },
    mode: AnalyticsMode.ARRIVAL_DATE,
};

const defaultRange = () => {
    return { from: now().subtract(1, "month").startOf("day"), to: now().endOf("day") };
};

interface CustomerAnalyticsStoreState {
    to?: Dayjs;
    from?: Dayjs;
    getFrom: () => Dayjs;
    getTo: () => Dayjs;
    filters: CustomerAnalyticsFilter;
    setFilters: (filters: Partial<CustomerAnalyticsFilter>) => void;
    resetFilters: (filters?: Partial<CustomerAnalyticsFilter>) => void;
    setFrom: (date: Dayjs) => void;
    setTo: (date: Dayjs) => void;
    getDateParams: () => Record<string, string>; // Not sure why `DateParamsProps` does not work
}

export const useCustomerAnalyticsFilterStore = create<CustomerAnalyticsStoreState>((set, get) => ({
    from: undefined,
    to: undefined,
    filters: defaultFilters,

    getDateParams() {
        const { mode } = get().filters;
        const name = mode === AnalyticsMode.ARRIVAL_DATE ? DateFilterRange.ARRIVAL_DATE : DateFilterRange.CREATED_AT;
        const params = [
            formatDate(get().getFrom(), DateFormat.DATE_TIME_ISO),
            formatDate(get().getTo(), DateFormat.DATE_TIME_ISO),
        ];
        return { [name]: params.join(",") };
    },

    setFilters(filters: Partial<CustomerAnalyticsFilter>) {
        set((state) => ({ filters: { ...state.filters, ...filters } }));
    },

    resetFilters(filters?: Partial<CustomerAnalyticsFilter>) {
        set({ filters: { ...defaultFilters, ...filters } });
    },

    getFrom() {
        return get().from ?? defaultRange().from;
    },

    getTo() {
        return get().to ?? defaultRange().to;
    },

    setFrom(from: Dayjs) {
        set(() => ({ from }));
    },

    setTo(to: Dayjs) {
        set(() => ({ to }));
    },
}));
